export const CSRF_HEADER = 'X-CSRF-Token';
export const CSRF_SAFE_METHODS = new Set(['GET', 'HEAD', 'OPTIONS', 'TRACE']);

let csrfToken: string | null = null;

export function getCsrfToken(): string | null {
  return csrfToken;
}

export function captureCsrfToken(response: Response): void {
  csrfToken = response.headers.get(CSRF_HEADER) ?? csrfToken;
}

export function clearCsrfToken(): void {
  csrfToken = null;
}
